import React from "react";

// Icon Imports
import {
 MdRestaurantMenu, MdDining
} from "react-icons/md";

import Recipe from "./views/admin/recipe";
import CreateRecipe from "./views/admin/recipe/CreateRecipe";
const routesRecipe = [
    {
        name: "Recipe",
        layout: "/admin",
        icon: <MdRestaurantMenu className="h-5 w-5"/>,
        path: "/recipe-menu",
        component: <Recipe/>,
    },
    // {
    //     name: "Recipe Creator",
    //     layout: "/admin",
    //     icon: <MdDining className="h-5 w-5"/>,
    //     path: "/recipe-create",
    //     component: <CreateRecipe />,
    // }
];

export default routesRecipe;
